import { render } from "./ListarBandeirasPagamentos.vue?vue&type=template&id=12263b08"
import script from "./ListarBandeirasPagamentos.vue?vue&type=script&lang=js"
export * from "./ListarBandeirasPagamentos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__